import useMediaQuery from 'embed_v2/hooks/useMediaQuery'

const useResponsiveWidth = (width: string) => {
  const matchesTablet = useMediaQuery('(max-width: 1170px)')
  const matchesMobile = useMediaQuery('only screen and (min-width: 0px) and (max-width: 770px)')

  const widthWithPadding = width === '100%' ? '100%' : '95%'

  if (matchesMobile) {
    return {
      width: 'auto',
      maxWidth: widthWithPadding
    }
  }

  if (matchesTablet) {
    return {
      maxWidth: widthWithPadding
    }
  }
}

export default useResponsiveWidth
